import { useTheme } from '@mui/material';

interface IProps {
  size: number;
  fill?: string;
}

export const InstagramIcon = ({ size, fill }: IProps) => {
  const theme = useTheme();

  return (
    <svg id="instagramicon__assets-icons-v2__svg__l12"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill ?? 'none'}
    stroke={theme.palette.common.white}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-brand-instagram">
      
      <path id="instagramicon__assets-icons-v2__path__l24" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="instagramicon__assets-icons-v2__path__l25" d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
      <path id="instagramicon__assets-icons-v2__path__l26" d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
      <path id="instagramicon__assets-icons-v2__path__l27" d="M16.5 7.5l0 .01" />
    </svg>);

};